import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>{props.title ? props.title + " | " : null} Uttar Pradesh State Legal Services Authority (UPSLA) | India</title>
    </Helmet>
  );
};
export default Head;
